/* This file is maintained for backwards compatibility.
 * New location is the @udemy/system-utils package. See:
 * https://github.com/udemy/design-system-web/blob/main/packages/shared-utils/src/env/server-or-client.ts
 * */
import {serverOrClient} from '@udemy/shared-utils';

// eslint-disable-next-line import/no-default-export
export default serverOrClient;
